import React from 'react';
import { painPoints } from '../data/salesCopy';
export function PainPoints() {
  return <section className="bg-cream-deep py-12 sm:py-20" aria-labelledby="situaciones" data-id="element-94" data-mp="2ln2gcak8bfqj">
      <div className="mx-auto max-w-6xl px-4 sm:px-6" data-id="element-95" data-mp="26yfs1jcmjdn6">
        <h2 id="situaciones" className="max-w-2xl font-display text-[1.6rem] font-semibold leading-tight text-ink sm:text-4xl" data-id="element-96" data-mp="26xmpkukp7aau">
          ¿Te suena familiar alguna de estas situaciones?
        </h2>

        <dl className="mt-8 divide-y divide-ink/10 border-y border-ink/10 sm:mt-12" data-id="element-97" data-mp="1xw6hithcvk9s">
          {painPoints.map((point, index) => <div key={point.title} className="grid gap-1.5 py-6 sm:grid-cols-[auto_1fr] sm:gap-8 sm:py-7 lg:grid-cols-[auto_0.8fr_1.2fr]" data-id="element-98" data-mp="21x8ipfuu26ee" data-mpi={index}>
              <span className="font-display text-base text-champagne sm:text-lg" data-id="element-99" data-mp="1sy4yg8jxjkyb">
                {String(index + 1).padStart(2, '0')}
              </span>
              <dt className="font-display text-lg text-ink sm:text-2xl" data-id="element-100" data-mp="3iee8w9e1n3yy">{point.title}</dt>
              <dd className="text-[15px] leading-relaxed text-ink/70 sm:text-base" data-id="element-101" data-mp="3nbwhtzs29j6y">{point.body}</dd>
            </div>)}
        </dl>

        <p className="mt-8 font-display text-lg italic text-ink/80 sm:mt-10 sm:text-2xl" data-id="element-102" data-mp="1u1lm12egvf67">
          Si te identificaste con alguna, no es tu culpa. Es que nadie te enseñó el sistema completo.
        </p>
      </div>
    </section>;
}